import "react-app-polyfill/stable";
import React, { Suspense } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route } from "react-router-dom";
import smoothscroll from "smoothscroll-polyfill";
import { getProfileCheckerAuthQueryParams } from "shared-auth";
import { initI18N } from "i18n";
import { LaunchDarklyProvider } from "shared-services";
import {
  AnalyticsProvider,
  AuthProvider,
  ErrorTrackingProvider,
  Spinner,
  TranslationContextProvider,
} from "component-library";
import TagManager from "react-gtm-module";
import App from "./app/App";

import { config } from "config";

import "./index.css";
import "./app/App.scss";
import GoogleAnalyticsProvider from "components/common/GoogleAnalyticsProvider/GoogleAnalyticsProvider";

TagManager.initialize({
  gtmId: config.gtm.gtmId,
  dataLayerName: config.gtm.dataLayerName,
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

smoothscroll.polyfill();

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);

initI18N(["performer"])
  .then(() => {
    root.render(
      <BrowserRouter>
        <AuthProvider extraQueryParams={getProfileCheckerAuthQueryParams()}>
          <GoogleAnalyticsProvider>
            <AnalyticsProvider>
              <ErrorTrackingProvider appName="profile-app">
                <LaunchDarklyProvider>
                  <QueryClientProvider client={queryClient}>
                    <TranslationContextProvider>
                      <Suspense fallback={<Spinner />}>
                        <Route path="/" component={App} />
                      </Suspense>
                    </TranslationContextProvider>
                  </QueryClientProvider>
                </LaunchDarklyProvider>
              </ErrorTrackingProvider>
            </AnalyticsProvider>
          </GoogleAnalyticsProvider>
        </AuthProvider>
      </BrowserRouter>
    );
  })
  .catch((error) => {
    console.error(error);
  });
